import type { RouteRecordRaw } from 'vue-router';

/**
 * ADMIN-T012 / ADMIN-T066 — dashboard route table per SPEC §5.2.
 * `readOnly: true` is enforced at runtime in ADMIN-T062 (no write actions allowed).
 *
 * ADMIN-T066: cockpit, profile, archive wired to real BI components.
 * ADMIN-T349: response wired to ResponseEfficiencyPage.vue (BI-T171).
 * ADMIN-T351: warranty-bi wired to WarrantyBiPage.vue (BI-T172).
 * ADMIN-T351: finance-bi wired to FinanceBiPage.vue (BI-T173).
 */
export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    redirect: '/dashboard/cockpit',
  },
  {
    path: '/dashboard/cockpit',
    name: 'dashboard.cockpit',
    component: () => import('@/modules/dashboard/CockpitPage.vue'),
    meta: {
      permission: 'dashboard:cockpit:read',
      data_scope: 'global',
      lazy_chunk_name: 'DashboardCockpit',
      title: '驾驶舱',
      readOnly: true,
    },
  },
  {
    path: '/dashboard/response',
    name: 'dashboard.response',
    component: () => import('@/modules/dashboard/ResponseEfficiencyPage.vue'),
    meta: {
      permission: 'dashboard:response:read',
      data_scope: 'global',
      lazy_chunk_name: 'DashboardResponseEfficiency',
      title: '响应效率',
      readOnly: true,
    },
  },
  {
    path: '/dashboard/warranty-bi',
    name: 'dashboard.warranty-bi',
    component: () => import('@/modules/dashboard/WarrantyBiPage.vue'),
    meta: {
      permission: 'dashboard:warranty:read',
      data_scope: 'global',
      lazy_chunk_name: 'DashboardWarrantyBi',
      title: '质保/维保报告',
      readOnly: true,
    },
  },
  {
    path: '/dashboard/finance-bi',
    name: 'dashboard.finance-bi',
    component: () => import('@/modules/dashboard/FinanceBiPage.vue'),
    meta: {
      permission: 'dashboard:finance:read',
      data_scope: 'global',
      lazy_chunk_name: 'DashboardFinanceBi',
      title: '财务节点报告',
      readOnly: true,
    },
  },
  {
    path: '/dashboard/profile',
    name: 'dashboard.profile',
    component: () => import('@/modules/dashboard/ProfileListPage.vue'),
    meta: {
      permission: 'dashboard:profile:read',
      data_scope: 'global',
      lazy_chunk_name: 'DashboardProfile',
      title: '员工画像',
      readOnly: true,
    },
  },
  {
    path: '/dashboard/archive',
    name: 'dashboard.archive',
    component: () => import('@/modules/dashboard/ArchiveListPage.vue'),
    meta: {
      permission: 'dashboard:archive:read',
      data_scope: 'global',
      lazy_chunk_name: 'DashboardArchive',
      title: '档案与报告',
      readOnly: true,
    },
  },
];
